import LinkifyIt from 'linkify-it';
import DOMPurify from 'dompurify';
const marked = require('marked')

const linkifier = new LinkifyIt();
linkifier.tlds('xyz', true);

export function formatTaskName(name) {
  let matches;
  if (!linkifier.pretest(name) || !(matches = linkifier.match(name))) {
    // No formatting.
    return null;
  }
  const result = [];
  let indexedEnd = 0;
  for (const match of matches) {
    if (match.index > indexedEnd) {
      result.push({
        tag: 'span',
        text: name.substring(indexedEnd, match.index),
      });
    }
    result.push({
      tag: 'a',
      text: match.text,
      attrs: {
        href: match.url,
      },
    });
    indexedEnd = match.lastIndex;
  }
  if (indexedEnd < name.length) {
    result.push({
      tag: 'span',
      text: name.substring(indexedEnd),
    });
  }
  return result;
}

export function parseMarkdown(input) {
  const normalized = input.trim()
  const html = marked.parse(normalized).trim()
  // Only produce html if there is some actual markup
  // that would result in actual formatting.
  if (html === `<p>${normalized}</p>`) return null
  return DOMPurify.sanitize(html);
}

export function parseDuration(name) {
  const regex = /\((\d+)\)/;
  const found = name.match(regex);
  if (found) {
    return parseInt(found[1])
  }
}
